module.exports = __webpack_public_path__ + "img/chain01.48220a01.png";